import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "../supabase";

const TYPES = {
  error:    { title: '오류 문의',    submitLabel: '제출하기' },
  feedback: { title: '피드백 보내기', submitLabel: '피드백 보내기' },
  review:   { title: '리뷰 남기기',  submitLabel: '리뷰 등록하기' },
  refund:   { title: '환불 요청',    submitLabel: '환불 요청하기' },
};

const TYPE_LABEL = {
  error: '오류 문의',
  feedback: '피드백',
  review: '리뷰',
  refund: '환불 요청',
};

const IconBack = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="bk" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#bk)">
      <path d="M11.625 15.7917L5.83333 10L11.625 4.20833L12.8125 5.39583L8.20833 10L12.8125 14.6042L11.625 15.7917Z" fill="#111111"/>
    </g>
  </svg>
);

const IconDropdown = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="ddm" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#ddm)">
      <path d="M10 12.774L5.28857 8.06253L6.06253 7.28857L10 11.2261L13.9375 7.28857L14.7115 8.06253L10 12.774Z" fill="#111111"/>
    </g>
  </svg>
);

function CardSection({ title, sub, children }) {
  return (
    <div style={{ background: '#ffffff', border: '1px solid #111111', borderRadius: 12, overflow: 'visible' }}>
      <div style={{ background: '#111111', color: '#ffffff', padding: '9px 14px', fontSize: 15, fontWeight: 600, letterSpacing: 1, display: 'flex', alignItems: 'center', gap: 6, borderRadius: '12px 12px 0 0' }}>
        {title} {sub && <span style={{ fontWeight: 400, fontSize: 15, color: '#888888' }}>{sub}</span>}
      </div>
      <div style={{ padding: 14 }}>{children}</div>
    </div>
  );
}

function Notice({ items }) {
  return (
    <div style={{ background: '#f5f5f5', border: '1px solid #e0e0e0', borderRadius: 12, padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 5 }}>
      {items.map((item, i) => (
        <div key={i} style={{ fontSize: 15, color: '#555555', lineHeight: 1.6, display: 'flex', gap: 6 }}>
          <span style={{ color: '#888888', flexShrink: 0 }}>·</span>
          <span dangerouslySetInnerHTML={{ __html: item }} />
        </div>
      ))}
    </div>
  );
}

export default function InquiryPage({ user }) {
  const navigate = useNavigate();
  const { type } = useParams();
  const info = TYPES[type];

  const [content, setContent] = useState('');
  const [rating, setRating] = useState(0);
  const [pkg, setPkg] = useState('');
  const [payDate, setPayDate] = useState('');
  const [pkgOpen, setPkgOpen] = useState(false);
  const [dpOpen, setDpOpen] = useState(false);
  const [dpYear] = useState(2026);
  const [dpMonth, setDpMonth] = useState(4);
  const [submitted, setSubmitted] = useState(false);

  if (!info) return null;

  const PACKAGES = ['스타터 (550원 / 11개)', '레귤러 (2,500원 / 58개)', '프로 (4,900원 / 120개)'];

  const getDaysInMonth = (y, m) => new Date(y, m, 0).getDate();
  const getFirstDay = (y, m) => new Date(y, m - 1, 1).getDay();

  const handleSubmit = async () => {
    if (type === 'review' && rating === 0) { alert('별점을 선택해주세요'); return; }
    if ((type === 'error' || type === 'feedback') && !content.trim()) { alert('내용을 입력해주세요'); return; }
    if (type === 'refund' && !pkg) { alert('결제 패키지를 선택해주세요'); return; }

    await supabase.from('inquiries').insert({
      user_id: user?.id ?? null,
      type: TYPE_LABEL[type],
      content: content.trim() || null,
      rating: type === 'review' ? rating : null,
      package: type === 'refund' ? pkg : null,
      payment_date: type === 'refund' ? payDate : null,
    });

    setSubmitted(true);
  };

  if (submitted) return (
    <div style={{ minHeight: '100vh', background: '#f0f0f0', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 430, background: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Mono', monospace", gap: 12, padding: 32 }}>
        <div style={{ fontSize: 40 }}>✓</div>
        <div style={{ fontSize: 16, fontWeight: 600, color: '#111111' }}>접수가 완료됐어요!</div>
        <div style={{ fontSize: 15, color: '#888888', textAlign: 'center', lineHeight: 1.7 }}>빠르게 확인하고 처리해드릴게요.<br />감사합니다 :)</div>
        <button onClick={() => navigate('/my')}
          style={{ marginTop: 16, background: '#111111', color: '#ffffff', border: 'none', borderRadius: 8, padding: '12px 32px', fontSize: 15, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
          마이페이지로 돌아가기
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f0f0f0', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 430, background: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: "'DM Mono', monospace" }}>

        <div style={{ background: '#ffffff', borderBottom: '1px solid #111111', height: 52, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px', flexShrink: 0 }}>
          <button onClick={() => navigate('/my')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}>
            <IconBack />
          </button>
          <span style={{ fontSize: 15, fontWeight: 600, color: '#111111', letterSpacing: 1 }}>{info.title}</span>
          <div style={{ width: 20 }} />
        </div>

        <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 14, flex: 1 }}>

          {type === 'error' && <>
            <Notice items={['어떤 오류가 발생했는지 알려주시면 빠르게 확인하고 처리해드릴게요.']} />
            <CardSection title="상세 설명">
              <textarea value={content} onChange={e => setContent(e.target.value)} maxLength={500}
                placeholder="예) 직장상사 말투로 변환하려고 했는데 '변환 실패'라는 메시지가 계속 뜨고 결과가 나오지 않아요."
                style={{ width: '100%', minHeight: 140, border: 'none', resize: 'none', fontSize: 16, lineHeight: 1.7, color: '#111111', background: 'transparent', padding: 0, fontFamily: "'DM Mono', monospace", outline: 'none' }} />
              <div style={{ fontSize: 16, color: '#bbbbbb', textAlign: 'right' }}>{content.length} / 500</div>
            </CardSection>
          </>}

          {type === 'feedback' && <>
            <Notice items={['더 좋은 서비스를 만들기 위해 소중한 의견을 들려주세요.']} />
            <CardSection title="의견 내용">
              <textarea value={content} onChange={e => setContent(e.target.value)} maxLength={500}
                placeholder="예) 소개팅 상대 말투에 상황별 옵션을 더 추가해주세요!"
                style={{ width: '100%', minHeight: 140, border: 'none', resize: 'none', fontSize: 16, lineHeight: 1.7, color: '#111111', background: 'transparent', padding: 0, fontFamily: "'DM Mono', monospace", outline: 'none' }} />
              <div style={{ fontSize: 16, color: '#bbbbbb', textAlign: 'right' }}>{content.length} / 500</div>
            </CardSection>
          </>}

          {type === 'review' && <>
            <Notice items={['여러분의 리뷰는 서비스 성장에 큰 힘이 됩니다.']} />
            <CardSection title="별점 평가" sub="(필수)">
              <div style={{ display: 'flex', gap: 4, justifyContent: 'center', padding: '6px 0' }}>
                {[1,2,3,4,5].map(s => (
                  <span key={s} onClick={() => setRating(s)}
                    style={{ fontSize: 40, color: s <= rating ? '#FFD700' : '#e0e0e0', cursor: 'pointer' }}>★</span>
                ))}
              </div>
              <div style={{ textAlign: 'center', fontSize: 15, color: '#888888' }}>{rating > 0 ? `${rating}점 / 5점` : '별점을 선택해주세요'}</div>
            </CardSection>
            <CardSection title="리뷰 내용" sub="(선택)">
              <textarea value={content} onChange={e => setContent(e.target.value)} maxLength={300}
                placeholder="예) 직장상사한테 보내기 전에 항상 여기서 다듬는데 진짜 유용해요. 덕분에 사회생활 가능해졌어요 ㅋㅋ"
                style={{ width: '100%', minHeight: 100, border: 'none', resize: 'none', fontSize: 16, lineHeight: 1.7, color: '#111111', background: 'transparent', padding: 0, fontFamily: "'DM Mono', monospace", outline: 'none' }} />
              <div style={{ fontSize: 16, color: '#bbbbbb', textAlign: 'right' }}>{content.length} / 300</div>
            </CardSection>
          </>}

          {type === 'refund' && <>
            <Notice items={['사용하지 않은 말풍선만 환불 가능합니다.', '결제 후 <strong>7일 이내</strong> 요청하셔야 환불이 가능해요.', '무료로 지급된 말풍선은 환불이 어렵습니다.']} />

            <CardSection title="결제 패키지">
              <div style={{ position: 'relative' }}>
                <div onClick={() => setPkgOpen(o => !o)}
                  style={{ width: '100%', padding: '10px 44px 10px 16px', border: '1px solid #111111', borderRadius: 8, fontSize: 15, color: pkg ? '#111111' : '#888888', background: '#ffffff', cursor: 'pointer', display: 'flex', alignItems: 'center', position: 'relative', userSelect: 'none' }}>
                  <span>{pkg || '패키지를 선택해주세요'}</span>
                  <span style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', pointerEvents: 'none' }}><IconDropdown /></span>
                </div>
                {pkgOpen && (
                  <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, background: '#ffffff', border: '1px solid #111111', borderRadius: 12, overflow: 'hidden', zIndex: 100 }}>
                    {PACKAGES.map((p, i) => (
                      <div key={p} onClick={() => { setPkg(p); setPkgOpen(false); }}
                        style={{ padding: '11px 16px', fontSize: 15, color: '#111111', cursor: 'pointer', borderBottom: i < PACKAGES.length - 1 ? '1px solid #eeeeee' : 'none', fontWeight: pkg === p ? 700 : 400, background: pkg === p ? '#f5f5f5' : '#ffffff' }}>
                        {p}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </CardSection>

            <CardSection title="결제일" sub="(선택)">
              <div style={{ position: 'relative' }}>
                <div onClick={() => setDpOpen(o => !o)}
                  style={{ width: '100%', padding: '10px 44px 10px 16px', border: '1px solid #111111', borderRadius: 8, fontSize: 15, color: payDate ? '#111111' : '#888888', background: '#ffffff', cursor: 'pointer', display: 'flex', alignItems: 'center', position: 'relative', userSelect: 'none' }}>
                  <span>{payDate || '날짜를 선택해주세요'}</span>
                  <span style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', pointerEvents: 'none' }}><IconDropdown /></span>
                </div>
                {dpOpen && (
                  <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, border: '1px solid #111111', borderRadius: 12, overflow: 'hidden', background: '#ffffff', zIndex: 100 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderBottom: '1px solid #eeeeee', background: '#f5f5f5' }}>
                      <button onClick={e => { e.stopPropagation(); setDpMonth(m => m === 1 ? 12 : m - 1); }} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#111111', padding: '2px 8px', fontFamily: "'DM Mono', monospace" }}>‹</button>
                      <span style={{ fontSize: 15, fontWeight: 600, color: '#111111' }}>{dpYear}년 {dpMonth}월</span>
                      <button onClick={e => { e.stopPropagation(); setDpMonth(m => m === 12 ? 1 : m + 1); }} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#111111', padding: '2px 8px', fontFamily: "'DM Mono', monospace" }}>›</button>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', padding: 8, gap: 2 }}>
                      {['일','월','화','수','목','금','토'].map(d => (
                        <div key={d} style={{ fontSize: 15, color: '#bbbbbb', textAlign: 'center', padding: '3px 0' }}>{d}</div>
                      ))}
                      {Array.from({ length: getFirstDay(dpYear, dpMonth) }).map((_, i) => (
                        <div key={`e${i}`} />
                      ))}
                      {Array.from({ length: getDaysInMonth(dpYear, dpMonth) }).map((_, i) => {
                        const day = i + 1;
                        const dateStr = `${dpYear}-${String(dpMonth).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
                        const isSelected = payDate === dateStr;
                        return (
                          <div key={day} onClick={e => { e.stopPropagation(); setPayDate(dateStr); setDpOpen(false); }}
                            style={{ fontSize: 15, color: isSelected ? '#ffffff' : '#111111', textAlign: 'center', padding: '6px 2px', borderRadius: 8, cursor: 'pointer', background: isSelected ? '#111111' : 'transparent' }}>
                            {day}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </CardSection>

            <CardSection title="환불 사유" sub="(선택)">
              <textarea value={content} onChange={e => setContent(e.target.value)}
                placeholder="예) 서비스를 더 이상 사용하지 않을 것 같아서 환불 요청드립니다."
                style={{ width: '100%', minHeight: 80, border: 'none', resize: 'none', fontSize: 16, lineHeight: 1.7, color: '#111111', background: 'transparent', padding: 0, fontFamily: "'DM Mono', monospace", outline: 'none' }} />
            </CardSection>
          </>}

        </div>

        <div style={{ padding: '0 16px 24px', flexShrink: 0 }}>
          <button onClick={handleSubmit}
            style={{ width: '100%', background: '#111111', color: '#ffffff', border: 'none', borderRadius: 8, padding: '15px 20px', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
            {info.submitLabel}
          </button>
        </div>

      </div>
    </div>
  );
}